module.exports = __webpack_public_path__ + "img/Galactapedia_Drake_Interplanetary.b402834a.png";